import React from 'react';
import { useParams } from 'react-router';
import PageContainer from '../../layout/PageContainer';
import CorredorLiquidacionDetalle from '../liquidacion/CorredorLiquidacionDetalle';

const CorredorLiquidacionGarantiaDetalleContainer = () => {
  const { liquidacionId } = useParams();
  return (
    <PageContainer
      breadcrumbs={[
        { id: 0, name: 'SEGURO DE CRÉDITO', url: '/' },
        { id: 1, name: 'CORREDOR', url: '/corredor/polizas-garantia' },
        { id: 2, name: 'LIQUIDACIÓN GARANTÍA', url: '/corredor/liquidacion-garantia' },
        { id: 3, name: 'DETALLE' },
      ]}
      clientFilter={{
        type: 'corredor',
        ramo: 'garantia',
        showFilter: false,
      }}
    >
      {(corredor) => (
        <CorredorLiquidacionDetalle
          liquidacionId={liquidacionId}
          corredor={corredor}
          tipo="garantia"
        />
      )}
    </PageContainer>
  );
};

export default CorredorLiquidacionGarantiaDetalleContainer;
